import PropTypes from 'prop-types';

export default PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    url: PropTypes.string,
    brandName: PropTypes.string,
    languageCode: PropTypes.string,
    isPrivate: PropTypes.bool,
    description: PropTypes.string,
    affiliates: PropTypes.object
})